import React, { useState } from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
  FormControl,
  NativeSelect,
  InputBase,
  Button,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import PageviewIcon from "@material-ui/icons/Pageview";
import { palette, useStylesGlobal } from "configurations/styles/theme";
import {getAnioActual } from "../../../redux/actions/userActions";
import { typeVouchers,tipoAnio} from "./typeVoucher";

import Swal from "sweetalert2";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import ClearAllIcon from "@material-ui/icons/ClearAll";
import { useSnackbar } from 'notistack';

const currentYear = new Date().getFullYear();
const startYear = 2015; 
const years = Array.from({ length: currentYear - startYear + 1 }, (_, index) => startYear + index).reverse();
const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    marginBottom: "0.5%",
  },
  heading: {
    fontSize: theme.typography.pxToRem(14),
    fontWeight: theme.typography.fontWeightRegular,
    color: palette.primary.menuHeader,
  },
  accordionSumary: {
    backgroundColor: palette.primary.light,
  },
  margin: {
    margin: theme.spacing(0),
    width: "100%",
    marginBottom: "1%",
  },
}));

const BootstrapInput = withStyles((theme) => ({
  root: {
    "label + &": {
      marginTop: theme.spacing(0),
    },
  },
  input: {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #ced4da",
    fontSize: 16,
    padding: "10px 26px 10px 12px",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:focus": {
      borderRadius: 4,
      borderColor: "#80bdff",
      boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
    },
  },
}))(InputBase);

export default function SearcVoucher({
  update,
  setUpdate,
  setParamSearch,
}) {

  const classes = useStyles();
  const classesGlobal = useStylesGlobal();
  const [dateStart, setDateStart] = useState("");
  const [dateEnd, setDateEnd] = useState("");
  const [codigoEstablecimiento, setEstablecimiento] = useState("");
  const [puntoEmision, setPuntoEmision] = useState("");
  const [sequential, setSequential] = useState("");
  const [seqFinal, setSeqFinal] = useState("");
  const [identifier, setIdentifier] = useState("");
  const [type, setType] = useState("");
  const { enqueueSnackbar } = useSnackbar();
  const [typeAnio, setTypeAnio] = useState("2025");

  //Para utilizar la fecha

  const validationInputs = () => {
    let cadena = "";
    if (
      dateStart.trim() === "" &&
      dateEnd.trim() === "" &&
      codigoEstablecimiento.trim() === "" &&
      puntoEmision.trim() === "" &&
      sequential.trim() === "" &&
      seqFinal.trim() === "" &&
      identifier.trim() === "" &&
      type.trim() === "" &&
      typeAnio.trim()==""

    ) {
      return enqueueSnackbar(`Ingrese al menos un parámetro`, {
        variant: "warning",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });

    } else {
      if (dateStart.trim() !== "" && dateEnd.trim() !== "") {
        cadena = `${cadena}&fechaInicio=${dateStart}&fechaFin=${dateEnd}`;
      }
      if (codigoEstablecimiento.trim() !== "") {
        if (codigoEstablecimiento.trim().length < 3) {
          return enqueueSnackbar(`El código de establecimiento debe tener 3 dígitos`, {
            variant: "warning",
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
          })
        } else
          cadena = `${cadena}&codigoEstablecimiento=${codigoEstablecimiento}`;
      }
      if (puntoEmision.trim() !== "") {
        if (puntoEmision.trim().length < 3) {
          return enqueueSnackbar(`El punto de emisión debe tener 3 dígitos`, {
            variant: "warning",
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
          })
        } else
          cadena = `${cadena}&puntoEmision=${puntoEmision}`;
      }
      if (sequential.trim() !== "" && seqFinal.trim() !== "") {
        let sequentialFrom = sequential;
        let sequentialTo = seqFinal;
        if (sequential.trim().length < 9 || seqFinal.trim().length < 9) {
          sequentialFrom = "0".repeat(9 - sequential.length) + sequential;
          sequentialTo = "0".repeat(9 - seqFinal.length) + seqFinal;
        }
        cadena = `${cadena}&secuencialFrom=${sequentialFrom}&secuencialTo=${sequentialTo}`;
      }
      if (identifier.trim() !== "") {
        cadena = `${cadena}&parametroReceptor=${identifier}`;
      }
      if (type.trim() !== "") {
        cadena = `${cadena}&codigoComprobante=${type}`;
      }
      cadena=cadena+getAnioActual(typeAnio) ;

    }

    //esto es con tabla paginada
    if (update === 3 || update === 2) {
      setUpdate(4);
    } else if (update === 4) {
      setUpdate(3);
    }
    //limpiar buscador
    //cleanInputs();
    //llamo al afuncion de búsqueda

    setParamSearch(cadena);
    //setUpdate(3);
  };

  const cleanInputs = () => {
    setDateStart("");
    setDateEnd("");
    setEstablecimiento("");
    setPuntoEmision("");
    setSequential("");
    setSeqFinal("");
    setIdentifier("");
    setType("");
    setUpdate(2);
  };

  return (
    <div className={classes.root}>
      <Accordion>
        <AccordionSummary
          expandIcon={
            <ExpandMoreIcon //style={{ color: palette.primary.contrastText }}
            />
          }
          aria-controls="panel1a-content"
          id="panel1a-header"
        // classes={{ root: classes.accordionSumary }}
        >
          <label className={classesGlobal.titleCard}>Búsqueda avanzada: </label>
          <label className={classesGlobal.click}><label>{" "}</label> (Clic Aquí)</label>
        </AccordionSummary>
        <AccordionDetails>

          <form style={{ width: "100%" }}>
            <Grid container spacing={1} justify="center">
              <Grid item xs={2}>
                <label>Fecha Inicial: </label>
              </Grid>
              <Grid item xs={4}>
                <input
                  type="date"
                  className="form-control"
                  name="dateStart"
                  value={dateStart}
                  onChange={(e) => setDateStart(e.target.value)}
                />
              </Grid>

              <Grid item xs={2}>
                <label>Fecha Final:</label>
              </Grid>
              <Grid item xs={4}>
                <input
                  type="date"
                  className="form-control"
                  name="dateEnd"
                  value={dateEnd}
                  onChange={(e) => setDateEnd(e.target.value)}
                />
              </Grid>
              <Grid item xs={2}>
                <label>Codigo Establecimiento:</label>
              </Grid>
              <Grid item xs={4}>
                <input
                  type="string"
                  className="form-control"
                  placeholder="Ej. 001"
                  name="codigoEstablecimiento"
                  maxLength="3"
                  value={codigoEstablecimiento}
                  onChange={(e) => setEstablecimiento(e.target.value)}
                />
              </Grid>
              <Grid item xs={2}>
                <label>Punto de Emisión:</label>
              </Grid>
              <Grid item xs={4}>
                <input
                  type="string"
                  className="form-control"
                  placeholder="Ej. 003"
                  name="puntoEmision"
                  maxLength="3"
                  value={puntoEmision}
                  onChange={(e) => setPuntoEmision(e.target.value)}
                />
              </Grid>


              <Grid item xs={2}>
                <label>Secuencial Inicial:</label>
              </Grid>
              <Grid item xs={4}>
                <input
                  type="string"
                  className="form-control"
                  placeholder="Ej. 000000001"
                  name="sequential"
                  maxLength="9"
                  value={sequential}
                  onChange={(e) => setSequential(e.target.value)}
                />
              </Grid>

              <Grid item xs={2}>
                <label>Secuencial Final:</label>
              </Grid>
              <Grid item xs={4}>
                <input
                  type="string"
                  className="form-control"
                  placeholder="Ej. 000000010"
                  name="seqFinal"
                  maxLength="9"
                  value={seqFinal}
                  onChange={(e) => setSeqFinal(e.target.value)}
                />
              </Grid>

              <Grid item xs={2}>
                <label>RUC / Cédula / Razón Social: </label>
              </Grid>
              <Grid item xs={4}>
                <input
                  type="string"
                  className="form-control"
                  name="identifier"
                  value={identifier}
                  onChange={(e) => setIdentifier(e.target.value)}
                />
              </Grid>
              <Grid item xs={2}>
                <label>Año:</label>
              </Grid>
              <Grid item xs={4}>
                <FormControl className="form-control">
                  <NativeSelect
                    value={typeAnio}
                    onChange={(e) => setTypeAnio(e.target.value)}
                    input={<BootstrapInput />}
                  >
                    
                    {years.map((voucher) => (
                      <option key={voucher} value={voucher}>
                        {voucher}
                      </option>
                    ))}
                  </NativeSelect>
                </FormControl>
              </Grid>

              <Grid item xs={2}>
                <label>Tipo:</label>
              </Grid>
              <Grid item xs={4}>
                <FormControl className="form-control">
                  <NativeSelect
                    value={type}
                    onChange={(e) => setType(e.target.value)}
                    input={<BootstrapInput />}
                  >
                    <option aria-label="None" value="">
                      --Seleccione--
                    </option>
                    {typeVouchers.map((voucher) => (
                      <option key={voucher.CODIGO} value={voucher.CODIGO}>
                        {voucher.NOMBRE}
                      </option>
                    ))}
                  </NativeSelect>
                </FormControl>
              </Grid>
             

              <Grid item xs={3}>
                <Button
                  variant="contained"
                  color="primary"
                  align="center"
                  startIcon={<PageviewIcon />}
                  onClick={validationInputs}
                >
                  {" "}
                  Buscar
                </Button>
              </Grid>
              <Grid item xs={3}>
                <Button
                  variant="outlined"
                  color="primary"
                  align="center"
                  startIcon={<ClearAllIcon />}
                  onClick={cleanInputs}
                >
                  {" "}
                  Limpiar / Mostrar Todos
                </Button>
              </Grid>
            </Grid>
          </form>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
